module.exports = __webpack_public_path__ + "img/6.f8a39a08.png";